import * as types from "@/store/mutation-types";
import { DefineMutations } from "vuex-type-helper";
import {
  PayPlanChangeRequestState,
  PayPlanChangeRequestMutations,
  StateKeys
} from "./types";
import {
  GenericDeleteItem,
  GenericSetEdit,
  GenericSetEditField,
  GenericSetItem,
  GenericSetState,
  GenericSetStates,
  GenericClearStore
} from "@/store/helpers";
import { IPayPlanChangeRequest } from "@/helpers/storageFormBaseInterface";
import { getPayPlanChangeRequestDefaults } from "@/helpers/getPayPlanChangeRequestDefaults";
import { defaultState } from "./state";
export const mutations: DefineMutations<
  PayPlanChangeRequestMutations,
  PayPlanChangeRequestState
> = {
  [types.SET_STATE]: GenericSetState<PayPlanChangeRequestState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<PayPlanChangeRequestState>(),
  [types.SET_EDIT]: GenericSetEdit<
    PayPlanChangeRequestState,
    string | IPayPlanChangeRequest
  >("payPlanChangeRequests", getPayPlanChangeRequestDefaults),
  [types.SET_EDIT_FIELD]: GenericSetEditField<
    PayPlanChangeRequestState,
    keyof IPayPlanChangeRequest
  >(),
  [types.SET_ITEM]: GenericSetItem<
    PayPlanChangeRequestState,
    IPayPlanChangeRequest
  >("payPlanChangeRequests", getPayPlanChangeRequestDefaults), //TODO: WRITE A getXDefaultsFunction and pass it here in place of the anonymous function
  [types.DELETE_ITEM]: GenericDeleteItem<PayPlanChangeRequestState>(
    "payPlanChangeRequests",
    "_id"
  ),
  [types.CLEAR_PAYPLAN_CHANGE_REQUEST_STORE]: GenericClearStore<
    PayPlanChangeRequestState
  >(defaultState())
};
